import { render, staticRenderFns } from "./quit.vue?vue&type=template&id=07fdb8b2&scoped=true&"
import script from "./quit.vue?vue&type=script&lang=js&"
export * from "./quit.vue?vue&type=script&lang=js&"
import style0 from "./quit.vue?vue&type=style&index=0&id=07fdb8b2&lang=scss&scoped=true&"
import style1 from "./quit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fdb8b2",
  null
  
)

export default component.exports